
import MenuUploadCategoryOptionTile from "../menu/menu-upload-category-option-tile.vue";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
import MenuUploadDraggableItem from "./menu-upload-draggable-item.vue";
import CreateModifyKotDialog from "../dialogs/create-modify-kot-dialog.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "MenuUploadCategory",
  components: {
    MenuUploadCategoryOptionTile,
    CreateModifyKotDialog,
    ConfirmationDialog,
    MenuUploadDraggableItem
  },
  props: {
    kotGroup: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      checkedKotGroup: {},
      showOptionsTile: false,
      selectedKot: {},
      selected: [],
      showKotDialog: false,
      showDeleteCategoryDialog: false,
      deleteLoading: false,
      options: [
        { id: "delete", label: "Delete" },
        { id: "rename", label: "Rename" }
      ]
    };
  },
  methods: {
    handleBtnClick() {
      this.showOptionsTile = !this.showOptionsTile;
    },
    handleDeleteKot() {
      this.selectedKot = this.kotGroup;
      this.showDeleteCategoryDialog = true;
    },
    handleRenameKot() {
      this.selectedKot = this.kotGroup;
      this.showKotDialog = true;
    },
    triggerDeleteKot(kotGroup) {},
    handleOptionClick(id) {
      if (id === "delete") {
        this.handleDeleteKot();
      } else {
        this.handleRenameKot();
      }
    }
  }
};
